/**
 * The 48px action row of the account panel (`AccountMenu`) and of the phone
 * drawer's account block: a muted 20px icon, then a 14px/700 ink label, the
 * bg-alt hover and the inset cobalt focus ring. `ButtonBase` keeps the
 * browser's control font, so the row sets `font: inherit` itself.
 */
export const accountRowSx = {
  display: 'flex',
  justifyContent: 'flex-start',
  gap: '12px',
  width: '100%',
  minHeight: 48,
  px: '12px',
  borderRadius: 'var(--radius-md)',
  color: 'var(--ink)',
  font: 'inherit',
  fontSize: 14,
  fontWeight: 700,
  letterSpacing: '-0.01em',
  lineHeight: 1.3,
  textAlign: 'left',
  transition: 'background-color 200ms var(--ease-default, ease-out)',
  '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
  '&:hover': { backgroundColor: 'var(--bg-alt)' },
  '&:focus-visible': { outline: '2px solid var(--cobalt)', outlineOffset: -2 },
  '&[aria-disabled="true"]': { opacity: 0.55, cursor: 'progress' },
  '& .MuiSvgIcon-root': {
    flexShrink: 0,
    fontSize: 20,
    color: 'var(--ink-muted)',
  },
} as const;
